// extracted by mini-css-extract-plugin
export var button = "_ni-2";
export var card = "_ni-0";
export var closeButtonContainer = "_ni-3";
export var iconContainer = "_ni-1";